/* eslint-disable */
import {
	ArrowDown, ArrowUp, ArrowUpDown, Download, Eye, SearchIcon
} from 'lucide-react';
import React, {
	useCallback, useEffect, useMemo, useState
} from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Input, InputGroup } from 'rsuite';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { urls } from '@/Constants';
import { inputHelper, keyPressHandler } from '@/Helpers';
import { tabs } from './tabs.constants';
import GrnHeader from '../GRNPage/grnHeader';
import SortComp from './SortComp';
import TableWithTabs from './TableWithTabs';
import Info from '@/Components/InfoTab/Info';
import useKeyPress from '@/Helpers/useKeyPress';
import { getTextColor, getTooltipTitle, useSessionStorageList } from './helper';
import { Tooltip } from '@mui/material';

const SORT_OPTIONS = [
	{
		value: 'productName', label: 'Product Name',
	},
	{
		value: 'orderedQty', label: 'Ordered Qty',
	},
	{
		value: 'producedQty', label: 'Produced Qty',
	},
	{
		value: 'producedPercentage', label: 'Produced %',
	},
];

const SORT_COST_OPTIONS = [
	{
		value: 'productName', label: 'Product Name',
	},
	{
		value: 'orderCost', label: 'Ordered Cost',
	},
	{
		value: 'packagedCost', label: 'Packaged Cost',
	},
	{
		value: 'variance', label: 'Variance',
	},
];

const WEIGHT_BASED_COLUMNS = [
	{
		title: 'Client Variant ID', key: 'clientVariantId',
	},
	{
		title: 'Product Name', key: 'productName',
	},
	{
		title: 'Price per Unit', key: 'pricePerUnit',
	},
	{
		title: 'Ordered Qty', key: 'orderedQty',
	},
	{
		title: 'Produced Qty', key: 'producedQty',
	},
	{
		title: 'Produced %', key: 'producedPercentage',
	},
	{
		title: 'View', key: 'view',
	},
];

const COST_BASED_COLUMNS = [
	{
		title: 'Client Variant ID', key: 'clientVariantId',
	},
	{
		title: 'Product Name', key: 'productName',
	},
	{
		title: 'Price per Unit', key: 'pricePerUnit',
	},
	{
		title: 'Ordered Cost', key: 'orderCost',
	},
	{
		title: 'Packaged Cost', key: 'packagedCost',
	},
	{
		title: 'Variance', key: 'variance',
	},
	{
		title: 'View', key: 'view',
	},
];

const FIELD_MAP = {
	StoreId: 'storeId',
	Type: 'storeType',
	'Total Packaging %': 'totalPackagingPercentage',
	'Total Packaged Cost': 'totalPackagedCost',
	'Total Ordered Weight': 'totalOrderedWeight',
	'Total Packaged Weight': 'totalPackagedWeight',
};

const TABLE_TAB_CONFIG = {
	tabList: [{
		id: 1,
		value: 'packaging',
		label: 'Packaged Quantity ',
	}],
	activeTabColor: 'bg-yellow-200',
};

const extractNumeric = (text) => {
	if (!text) return NaN;
	const num = parseFloat(String(text).replace(/[^\d.-]/g, ''));
	return isNaN(num) ? NaN : num;
};

const getTextFromElement = (element) => {
	if (!React.isValidElement(element)) return element;
	const { children } = element.props;

	if (Array.isArray(children)) {
		return children.map(getTextFromElement).join('');
	}
	if (React.isValidElement(children)) {
		return getTextFromElement(children);
	}
	return children ?? '';
};

const formatCurrency = (value) => `₹${parseFloat(value)?.toFixed(2)}`;
const formatQuantity = (value, unit) => `${parseFloat(value)?.toFixed(2)} ${unit}`;

const useProductData = (list, id) => {
	const [idx, setIdx] = useState(-1);
	const [productData, setProductData] = useState({});

	useEffect(() => {
		if (list?.length > 0) {
			const index = list?.findIndex((item) => item?.headerInfo?.podId == id);
			const obj = index !== -1 ? list[index] : null;
			setProductData(obj);
			setIdx(index);
		}
	}, [list, id]);

	return {
		productData, idx,
	};
};

function ProducedDetailComp({ name, id, filters, meal, rowIndex }) {
	const [uiState, setUiState] = useState({
		selectedTab: tabs[0]?.id,
		tableTab: 'packaging',
		search: '',
		isSortOpen: false,
		sortVal: {},
	});

	const list = useSessionStorageList();
	const { productData, idx } = useProductData(list, id);
	const keyPressed = useKeyPress();
	const history = useHistory();
	const storeList = useSelector((state) => state?.form?.STORES?.data?.LIST);

	console.log(productData, 'productData');

	const backUrl = useMemo(() => {
		return `${urls.EXTENSION}${urls.AI_FMS_PAGE}?parentValue=PRODUCED&mealType=${meal}&dateRange=${encodeURIComponent(JSON.stringify(filters?.dateRange))}&fromPodFilter=${filters?.fromPodFilter}&rowIndex=${idx}`;
	}, [meal, filters, idx]);

	const getStoreType = useCallback((podId) => {
		const store = storeList?.length > 0 ? storeList?.find((item) => item?.id == podId) : '';
		const type = store?.type;
		const subType = store?.subType;
		return subType ? `${type}(${subType})` : type;
	}, [storeList]);

	const productInfo = useMemo(() => {
		const headerInfo = productData?.headerInfo;
		if (!headerInfo) return {};

		return {
			storeId: headerInfo?.podId,
			podName: headerInfo?.podName,
			storeType: getStoreType(headerInfo?.podId),
			totalPackagingPercentage: `${headerInfo?.totalPackagingPercentage?.toFixed(2)}%`,
			totalPackagedCost: formatCurrency(headerInfo?.totalPackagedCost),
			totalOrderedWeight: formatQuantity(headerInfo?.totalOrderedWeight, headerInfo?.unit),
			totalPackagedWeight: formatQuantity(headerInfo?.totalPackagedWeight, headerInfo?.unit),
		};
	}, [productData?.headerInfo, getStoreType]);

	const updateUiState = useCallback((updates) => {
		setUiState((prev) => ({
			...prev, ...updates,
		}));
	}, []);

	const handleSortChange = useCallback((value, type) => {
		setUiState({
			...uiState,
			sortVal: {
				sortColumnName: value,
				sortType: type,
			},
		});
	}, [uiState?.selectedTab]);

	const navigateQc = useCallback((e) => {
		const { dataset } = inputHelper(e);
		let newListItem = null;

		if (dataset.type === 'next') {
			newListItem = list?.[idx + 1];
		} else {
			newListItem = list?.[idx - 1];
		}

		if (newListItem) {
			history.push({
				pathname: `${urls.EXTENSION}${urls.AI_FMS_DETAIL_PAGE}`,
				search: `mode=produced&id=${newListItem?.headerInfo?.podId}&name=${newListItem?.headerInfo?.podName}&meal=${meal}&filters=${encodeURIComponent(JSON.stringify(filters))}&rowIndex=${idx}`,
			});
		}
	}, [list, idx, history, meal, filters]);

	const handleExport = useCallback(() => {
		const isWeightTab = uiState.selectedTab === 'weight';
		const headers = isWeightTab ? [
			'Meal Name', 'Export Type', 'Client Variant ID', 'Product Name', 'Price per Unit', 'Ordered Qty', 'Produced Qty', 'Produced %',
		] : [
			'Meal Name', 'Export Type', 'Client Variant ID', 'Product Name', 'Price per Unit', 'Ordered Cost', 'Packaged Cost', 'Variance',
		];

		const data = productData?.list?.map((item) => (isWeightTab ? [
			meal ?? '-',
			'Produced Summary',
			item?.itemClientVariantId,
			item?.ingName,
			`${item?.actualRate?.toFixed(2) || item?.rate}/${item?.unit}`,
			formatQuantity(item?.orderQty, item?.unit),
			formatQuantity(item?.fullfilledQty, item?.unit),
			`${item?.packagedPercent}%`,
		] : [
			meal ?? '-',
			'Produced Summary',
			item?.itemClientVariantId,
			item?.ingName,
			`${item?.actualRate?.toFixed(2) || item?.rate}/${item?.unit}`,
			item?.orderQty * (item?.actualRate?.toFixed(2) || item?.rate),
			item?.packaged * (item?.actualRate?.toFixed(2) || item?.rate) || item?.packagedCost,
			item?.packagedCost - (item?.orderQty * (item?.actualRate?.toFixed(2) || item?.rate)),
		]));

		const csvData = [headers, ...data];
		const csvContent = csvData.map((row) => row.join(',')).join('\n');
		const blob = new Blob([csvContent], {
			type: 'text/csv;charset=utf-8;',
		});
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `${productData?.headerInfo?.podName}${filters?.dateRange ? moment(filters?.dateRange?.from).format('DD-MM-YYYY') : ''}-${filters?.dateRange ? moment(filters?.dateRange?.to).format('DD-MM-YYYY') : ''}.csv`;
		a.click();
		URL.revokeObjectURL(url);
	}, [uiState.selectedTab, productData, meal, filters]);

	const buttons = useMemo(() => [
		{
			label: 'Export',
			icon: <Download size={16} />,
			handleClick: handleExport,
			noLevelSpecific: true,
			style: 'bg-teal-600 text-white',
		},
	], [handleExport]);

	useEffect(() => {
		const newListItem = list?.[idx] ?? null;
		if (
			(keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
			newListItem !== null
		) {
			const targetItem = keyPressHandler(keyPressed, list, idx);
			if (targetItem) {
				history.push({
					pathname: `${urls.EXTENSION}${urls.AI_FMS_DETAIL_PAGE}`,
					search: `mode=produced&id=${targetItem?.headerInfo?.podId}&name=${targetItem?.headerInfo?.podName}&meal=${meal}&filters=${encodeURIComponent(JSON.stringify(filters))}&rowIndex=${idx}`,
				});
			}
		}
	}, [keyPressed]);

	const generatedData = useCallback(
		(list, customRowData = {}) => {
			const { sortColumnName: sortCol, sortType } = uiState?.sortVal;

			let result = list ? [...list] : [];

			if (sortCol && sortType && customRowData[sortCol]) {
				const renderFn = customRowData[sortCol];
				result.sort((a, b) => {
					const aVal = getTextFromElement(renderFn(a));
					const bVal = getTextFromElement(renderFn(b));

					const numA = extractNumeric(aVal);
					const numB = extractNumeric(bVal);

					if (!isNaN(numA) && !isNaN(numB)) {
						return sortType === 'ascending' ? numA - numB : numB - numA;
					}

					return sortType === 'ascending'
						? String(aVal).localeCompare(String(bVal))
						: String(bVal).localeCompare(String(aVal));
				});
			}

			const searchTerm = uiState.search?.toLowerCase()?.trim();
			if (searchTerm) {
				result = result.filter(
					(item) => item?.ingName?.toLowerCase()?.trim()?.includes(searchTerm) ||
						item?.itemClientVariantId?.toLowerCase()?.trim()?.includes(searchTerm)
				);
			}

			return result;
		},
		[uiState.search, uiState?.sortVal]
	);

	const createRowRenderer = useCallback((field, formatter) => (product) => (
		<span className='text-[12px]'>{formatter(product)}</span>
	), []);

	const createIngDataRenderer = useCallback((formatter) => (product) => (
		<div className='flex flex-col gap-2'>
			{product?.ingData?.map((item, index) => (
				<span key={index} className='text-[12px]'>
					{formatter(item)}
				</span>
			))}
		</div>
	), []);

	const getWeightBasedTable = useMemo(() => {
		const customRowData = {
			clientVariantId: createRowRenderer('clientVariantId', (product) => product?.itemClientVariantId),
			productName: createRowRenderer('productName', (product) => product?.ingName),
			pricePerUnit: (product) => (
				<div className='flex flex-col gap-2'>
					{product?.ingData?.map((item, index) => (
						<span key={index} className='text-[12px]'>
							{formatCurrency(product?.actualRate?.toFixed(2) || item?.rate)}
							/
							{item?.unit}
						</span>
					))}
				</div>
			),
			orderedQty: createIngDataRenderer((item) => formatQuantity(item?.orderQty, item?.unit)),
			producedQty: createIngDataRenderer((item) => formatQuantity(item?.fullfilledQty, item?.unit)),
			producedPercentage: createRowRenderer('producedPercentage', (product) => (
				<Tooltip title={getTooltipTitle(product?.fullfilledQty, product?.orderQty, 'produced')}>
					<span className={`text-[12px] ${getTextColor(product?.fullfilledQty, product?.orderQty)}`}>{`${product?.packagedPercent}%`}</span>
				</Tooltip>
			)),
			view: (product) => (
				<Eye
					className='text-[10px] cursor-pointer transition-transform duration-200 hover:scale-125'
					onClick={() => window.open(
						`${urls.EXTENSION}${urls?.COOKING_ANALYSIS_LIST}?flag=${true}&name=${encodeURIComponent(product?.ingName)}&mealType=${meal}&dateRange=${encodeURIComponent(
							JSON.stringify(filters?.dateRange)
						)}&fromPod=${encodeURIComponent(JSON.stringify(filters?.fromPodFilter))}&toPod=${encodeURIComponent(JSON.stringify({ id: productData?.headerInfo?.podId, name: productData?.headerInfo?.podName }))}`
					)}
				/>
			),
		};

		return {
			data: generatedData(productData?.list, customRowData),
			tableRows: customRowData,
			tableColumns: WEIGHT_BASED_COLUMNS,
		};
	}, [productData?.list, generatedData, createRowRenderer, createIngDataRenderer, id, meal, filters]);

	const getCostBasedTable = useMemo(() => {
		const customRowData = {
			clientVariantId: createRowRenderer('clientVariantId', (product) => product?.itemClientVariantId),
			productName: createRowRenderer('productName', (product) => product?.ingName),
			pricePerUnit: (product) => {
				if (product?.ingData && product?.ingData?.length > 0) {
					return (
						<div className='flex flex-col gap-2'>
							{product?.ingData?.map((item, index) => (
								<span key={index} className='text-[12px]'>
									{formatCurrency(product?.actualRate?.toFixed(2) || item?.rate)}/{item?.unit}
								</span>
							))}
						</div>
					);
				} else {
					return (
						<span className='text-[12px]'>
							{formatCurrency(product?.actual?.toFixed(2) || product?.rate)}/{product?.unit}
						</span>
					);
				}
			},
			orderCost: (product) => {
				if (product?.ingData && product?.ingData?.length > 0) {
					return (
						<div className='flex flex-col gap-2'>
							{product?.ingData?.map((item, index) => (
								<span key={index} className='text-[12px]'>
									{formatCurrency(item?.orderQty * (product?.actualRate?.toFixed(2) || item?.rate))} {item?.unit}
								</span>
							))}
						</div>
					);
				} else {
					return (
						<span className='text-[12px]'>
							{formatCurrency(product?.orderQty * (product?.actual?.toFixed(2) || product?.rate))} {product?.unit}
						</span>
					);
				}
			},
			packagedCost: createRowRenderer('packagedCost', (product) => `${formatCurrency((product?.packaged * (product?.actualRate?.toFixed(2) || product?.rate)) || product?.packagedCost)} ${product?.unit}`),
			variance: (product) => (
				<div className='flex flex-col gap-2'>
					{product?.ingData?.map((item, index) => {
						const orderCost = Number((item?.orderQty * (product?.actualRate?.toFixed(2) || item?.rate)).toFixed(2));
						const packagedCost = Number((product?.packaged * (product?.actualRate?.toFixed(2) || product?.rate)) || product?.packagedCost);
						const diffOrderedCostFullfilledCost = Number(Math.abs(orderCost - packagedCost).toFixed(0));

						if (
							orderCost &&
							diffOrderedCostFullfilledCost !== 0 &&
							Math.abs((packagedCost - orderCost) / orderCost) > 0.05
						) {
							if (orderCost > packagedCost) {
								return (
									<Tooltip title='With in the threshold (±5%)'>
										<span key={index} className='flex items-center gap-1 text-[12px] text-green-500'>
											(
											<ArrowDown size={12} className='text-green-500' />
											{diffOrderedCostFullfilledCost}
											)
										</span>
									</Tooltip>
								);
							}
							return (
								<Tooltip title='Outside the threshold (±5%)'>
									<span key={index} className='flex items-center gap-1 text-[12px] text-red-500'>
										(
										<ArrowUp size={12} className='text-red-500' />
										{diffOrderedCostFullfilledCost}
										)
									</span>
								</Tooltip>
							);
						}
						return <span key={index}>-</span>;
					})}
				</div>
			),
			view: (product) => (
				<Eye
					className='text-[10px] cursor-pointer transition-transform duration-200 hover:scale-125'
					onClick={() => window.open(
						`${urls.EXTENSION}${urls?.COOKING_ANALYSIS_LIST}?flag=${true}&name=${encodeURIComponent(product?.ingName)}&mealType=${meal}&dateRange=${encodeURIComponent(
							JSON.stringify(filters?.dateRange)
						)}&fromPod=${encodeURIComponent(JSON.stringify(filters?.fromPodFilter))}&toPod=${encodeURIComponent(JSON.stringify({ id: productData?.headerInfo?.podId, name: productData?.headerInfo?.podName }))}`
					)}
				/>
			),
		};

		return {
			data: generatedData(productData?.list, customRowData),
			tableRows: customRowData,
			tableColumns: COST_BASED_COLUMNS,
		};
	}, [productData?.list, generatedData, createRowRenderer, createIngDataRenderer, id, meal, filters]);

	const getTableInfo = useCallback(() => {
		return uiState.selectedTab === 'weight' ? getWeightBasedTable : getCostBasedTable;
	}, [uiState.selectedTab, getWeightBasedTable, getCostBasedTable]);

	const getTabInfo = useMemo(() => ({
		...TABLE_TAB_CONFIG,
		tabValue: uiState.tableTab,
		handleTabChange: (value) => updateUiState({
			tableTab: value,
		}),
	}), [uiState.tableTab, updateUiState]);

	const filteredTabs = useMemo(() => {
		return tabs?.filter((item) => item?.id !== 'percentage');
	}, []);

	const getSortType = (columnName, sortType) => {
		if (columnName) {
			const name = uiState.selectedTab === 'weight' ? SORT_OPTIONS.find(option => option.value === columnName)?.label : SORT_COST_OPTIONS.find(option => option.value === columnName)?.label;
			const sortTypeIcon = sortType === 'ascending' ? <ArrowUp size={16} /> : <ArrowDown size={16} />;
			return <span className='flex items-start gap-1'> <strong className='flex items-center gap-1'> <ArrowUpDown size={16} /> Sort By:</strong> {name} {sortTypeIcon}</span>;
		}
		return <span className='flex items-start gap-1'> <ArrowUpDown size={16} /> Sort By</span>;
	};

	return (
		<>
			<GrnHeader
				title='Back to Operations Summary'
				navigateLabel='Outlet Name'
				id={name}
				navigatePrevToolTip='Prev Product'
				navigateNextToolTip='next Product'
				navigateQC={navigateQc}
				listData={list}
				idx={idx}
				url={backUrl}
			/>
			<div className='relative top-[3rem] p-4'>
				<Info
					buttons={buttons}
					fieldMap={FIELD_MAP}
					data={productInfo}
					heading={{
						key: name,
					}}
				/>
				<div className='flex justify-between items-center'>
					<div className='w-fit inline-flex rounded-lg bg-[#FDE6AD] p-1 m-[12px]'>
						{filteredTabs.map((tab) => (
							<button
								key={tab.id}
								onClick={() => updateUiState({
									selectedTab: tab.id,
									sortVal: {},
								})}
								className={`px-4 py-2 flex items-center text-sm font-medium transition-all duration-200 rounded-md ${uiState.selectedTab === tab.id
									? 'bg-yellow-400 text-black shadow-sm'
									: 'text-gray-700 hover:bg-yellow-300/50'
									}`}
							>
								<span className='mr-2'>{tab.icon}</span>
								{tab.label}
							</button>
						))}
					</div>
					<div className='flex gap-2 items-center'>
						<InputGroup
							inside
							className='rounded-full !bg-gray-200 border border-gray-200 px-2 py-1 !w-[350px]'
						>
							<InputGroup.Button
								className='!bg-transparent !shadow-none pointer-events-none'
								style={{
									background: 'transparent',
									boxShadow: 'none',
									cursor: 'default',
								}}
							>
								<SearchIcon size={16} className='text-gray-500' />
							</InputGroup.Button>
							<Input
								placeholder='Search by Product Name or Client Variant ID'
								className='bg-transparent border-none focus:outline-none'
								style={{
									background: 'transparent',
									border: 'none',
								}}
								value={uiState.search}
								onChange={(value) => updateUiState({
									search: value,
								})}
							/>
						</InputGroup>
						<div className='relative'>
							<button
								onClick={() => updateUiState({
									isSortOpen: true,
								})}
								className='px-4 py-2 flex items-center text-sm font-medium transition-all duration-200 rounded-md bg-yellow-400 text-black shadow-sm'
							>
								{getSortType(uiState?.sortVal?.sortColumnName, uiState?.sortVal?.sortType)}
							</button>
							<SortComp
								isOpen={uiState.isSortOpen}
								setIsOpen={(isOpen) => updateUiState({
									isSortOpen: isOpen,
								})}
								onSortChange={handleSortChange}
								sortOptions={uiState.selectedTab === 'weight' ? SORT_OPTIONS : SORT_COST_OPTIONS}
							/>
						</div>
					</div>
				</div>
				<TableWithTabs
					tableInfo={getTableInfo()}
					tabInfo={getTabInfo}
				/>
			</div>
		</>
	);
}

export default React.memo(ProducedDetailComp);
